import React from 'react';

import { CaptionProps } from './Caption.interfaces';
import { useStyles } from './Caption.styles';

const Caption = (props: CaptionProps) => {
  const { text } = props;

  const classes = useStyles(props);

  return <div className={classes.root}>{text}</div>;
};

export default Caption;
